import React from "react"
import SubNavigation from "../components/sub-navigation"

export const useSubNavigation = (navItems, pagePath, urlParam) => {
  const subNavigation = (
    <SubNavigation
      navItems={ navItems }
      pagePath={ pagePath }
      urlParam={ urlParam }
    />
  )

  return subNavigation
}